{
  "list": {
    "title": "أجهزة التابلت",
    "add": "ربط جهاز تابلت",
    "columns": {
      "name": "اسم الجهاز",
      "branch": "الفرع",
      "status": "الحالة",
      "lastSeen": "آخر ظهور"
    },
    "neverSeen": "لم يظهر بعد",
    "searchPlaceholder": "بحث باسم الجهاز",
    "rowActions": {
      "trigger": "إجراءات {{name}}",
      "disable": "تعطيل",
      "enable": "تفعيل"
    }
  },
  "status": {
    "online": "متصل",
    "offline": "غير متصل",
    "disabled": "معطل"
  },
  "drawer": {
    "pairTitle": "ربط جهاز تابلت",
    "editTitle": "تعديل جهاز التابلت",
    "pairDescription": "أدخل رمز الربط الظاهر على جهاز التابلت، ثم اسم الجهاز وفرعه.",
    "editDescription": "تحديث اسم الجهاز وفرعه.",
    "fields": {
      "code": "رمز الربط",
      "name": "اسم الجهاز",
      "branch": "الفرع"
    },
    "codeFormat": "رمز الربط من ستة أرقام",
    "paired": "تم ربط جهاز التابلت بنجاح",
    "updated": "تم تحديث جهاز التابلت بنجاح"
  },
  "statusConfirm": {
    "disableTitle": "تعطيل جهاز التابلت؟",
    "enableTitle": "تفعيل جهاز التابلت؟",
    "disableDescription": "سيتوقف \"{{name}}\" فورا وتلغى عمليته المفتوحة ويلزم ربطه من جديد.",
    "enableDescription": "أدخل رمز الربط الظاهر على \"{{name}}\" لربطه وتفعيله.",
    "changed": "تم تغيير حالة جهاز التابلت بنجاح"
  }
}
